import { i18n, Messages } from '@lingui/core';
import { Locale } from '@/types/common';
import { locales, getNormalisedLocale } from '@/utils/i18n';

export const importLocale = (locale: string) => async () => {
  const lang = await import(`!!@lingui/loader!@/locales/${locale}.po`);
  return [locale, lang] as [string, { messages: Messages }];
};

export async function activate(
  importLocaleFn: () => Promise<[string, { messages: Messages }]>
) {
  const [locale, { messages }] = await importLocaleFn();
  i18n.load(locale, messages);
  i18n.activate(locale);
}

export const setLanguage = (locale: Locale) => {
  const normalisedLocale = getNormalisedLocale(locale);
  if (locales.includes(normalisedLocale)) {
    activate(importLocale(normalisedLocale));
  }
};
